<script setup>
import { Field, ErrorMessage } from 'vee-validate';
import { ref, watch, inject } from 'vue';
import { __, getFormValuesFromLocalStorage } from '@/utils';
import addressFields from './addressFields.vue';
import poFields from './PoFields.vue';

const {
	isExistingAccount,
	isPOAddress
} = inject('step2');

const { type } = defineProps(['type', 'label']);

const savedFields = getFormValuesFromLocalStorage();
const name = `${type}AddressType`;

const showPO = ref(savedFields?.[name] === 'byPO');
const showAddress = ref(savedFields?.[name] === 'byAddress');

const handleRadioChange = (value) => {
	showPO.value = value === 'byPO';
	showAddress.value = value === 'byAddress';
}

watch(isPOAddress, (newVal) => {
	handleRadioChange(newVal)
});
</script>
<template>
	<div class="fields">
		<div class="fields__head">
			<h6>
				{{ label }}
			</h6>
		</div><!-- /.fields__head -->

		<div class="radios-tab" v-if="!isExistingAccount">
			<ul>
				<li>
					<div class="radio">
						<Field type="radio" :name="name" value="byAddress" id="byAddress"
						 @change="handleRadioChange('byAddress')"/>

						<label for="byAddress">
							{{ __('By Address') }}
						</label>
					</div><!-- /.radio -->
				</li>
				<li>
					<div class="radio">
						<Field
							type="radio"
							:name="name"
							value="byPO"
							id="byPO"
							@change="handleRadioChange('byPO')"
						/>

						<label for="byPO">
							{{ __('according to P.O.') }}
						</label>
					</div><!-- /.radio -->
				</li>
			</ul>
			<div class="field">
				<ErrorMessage :name="name" as="span" class="field__error" />
			</div>
		</div><!-- /.radios-tab -->

		<poFields :name="type" v-if="showPO"/>

		<addressFields v-if="showAddress" :type="type"/>
	</div><!-- /.fields -->
</template>
